import { data } from 'jquery';
import { DatePipe } from '@angular/common';
import { OnChanges } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { ActivatedRoute, Router } from '@angular/router';
import { SiteService } from 'src/app/services/site.service';
import { ContactService } from 'src/app/services/contact.service';
import { GeneralService } from 'src/app/services/general.service';
import { CustomerService } from 'src/app/services/customer.service';
import { SalesleadService } from 'src/app/services/saleslead.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { SalesProjectService } from 'src/app/services/sales-project.service';
import { MapInformationService } from 'src/app/services/map-information.service';
import { MDBModalRef, MDBModalService, ToastService } from 'ng-uikit-pro-standard';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { NewContactComponent } from 'src/app/shared/new-contact/new-contact.component';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
declare var $: any;

import { DxSelectBoxComponent } from 'devextreme-angular';
import { SystemComponentService } from 'src/app/services/system-component.service';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
import { NewCustomerComponent } from '../../employee-activities/forms/new-customer/new-customer.component';
import { TranslateService } from '@ngx-translate/core';
//import { GoogleMapsLoaderService } from 'src/app/services/google-maps-loader.service';

@Component({
  selector: 'app-create-update-sales-project',
  templateUrl: './create-update-sales-project.component.html',
  styleUrls: ['./create-update-sales-project.component.scss']
})
export class CreateUpdateSalesProjectComponent implements OnInit, OnChanges {
  plusSiteButton: any;
  addCategoryButton: any;
  addConsultingButton: any;
  addSalesPersonButton: any;
  addCustomerButton: any;
  addRequestByButton: any;
  addVerticalMaButton: any;
  addProdSpeButton: any;
  addProdSpeButtonNOTBIDREASON:any

  _projectDetailForm: FormGroup;
  @Input() projectInfo: {
    projectid: any;
    projectname: any;
    projectaddress: string;
    projectnumber: number;
    statusid: number;
  };
  @Input() projectid;
  @Input() projectnumber;
  @Input() VieneDe;

  @Output() getprojectinfo: EventEmitter<any> = new EventEmitter<any>();
  @Output() onsave: EventEmitter<any> = new EventEmitter<any>();
  @Output() omitirsave: EventEmitter<any> = new EventEmitter<any>();
  @Output() ispipeline: EventEmitter<any> = new EventEmitter<any>();
  @Output() closemodal: EventEmitter<any> = new EventEmitter<any>();

  @Output() updateStatus: EventEmitter<any> = new EventEmitter<any>();
  now = new Date();
  /* Para details  */
  editableProducts: string[];

  bidStatusSelect = [];
  marketingSelect = [];
  verticalMarketSelect = [];
  siteSelect = [];
  customerSelect = [];
  productSpecifiedSelect = [];
  prevailingSelect = [];
  projectCategorySelect = [];
  /* FIN Para details  */
  consultingname = "";
  custawardprojectname = "";
  partestimaterequestbyname: any;
  custreqpricename: any;
  salesPersonSelect = [];
  notBidReasonSelect = [];
  awardToSelect = [];
  dataSource = [];

  popupServiceSite = false;
  popupCustomer = false;
  customerField = '';
  popupUtilityTable = false;
  popupMarketCampaign = false;
  popupMarketAnalysis = false;
  popupMarketRegion = false;
  popupMarketCompanies = false;
  popupNewContact = false;
  popupSalesPerson = false;

  customerDataSource: any=[];
  contactDataSource: any=[];
  customerWithCreditDataSource: any=[];
  events: Array<string> = [];
  employeesNoSalesSelect = [];
  modalRef: MDBModalRef;

  popupUtilityTableVertical = false;

  isnew: boolean = true;
  disableInputs: boolean = false;
  dateFormat = '';
  pipelineid = 0;
  cancelButtonDeletePrice: { text: any; elementAttr: { id: string; }; onClick: () => void; };
  saveButtonDeletePrice: { text: any; icon: string; elementAttr: { id: string; }; onClick: () => void; };
  addleadSatatus: { icon: string; type: string; onClick: () => void; };
  @Input('frompipelineid')
  set frompipelineid(frompipelineid: any) {
    if (frompipelineid > 0)
      this.pipelineid = frompipelineid;
    // if (project && project.projectid > 0)
    // this.setProjectInfo(project);
  }


  cancelButtonNewCustomer: any;
  saveButtonNewCustomer: any;
  saveNewButtonNewCustomer: any;
  saveEditButtonNewCustomer: any;
  DateFilter:number;
  millisecondsInDay = 24 * 60 * 60 * 1000;
  todayButton: any;
  prevDateButton: any;
  nextDateButton: any;

  DateFilterBid:number;
  todayButtonBid: any;
  prevDateButtonBid: any;
  nextDateButtonBid: any;

  DateFilterClose:number;
  todayButtonClose: any;
  prevDateButtonClose: any;
  nextDateButtonClose: any;
  settings:any={}
  formatCurrency:any={}
  customerDataSource2:any
  popupaddProdSpeButtonNOTBIDREASON:boolean = false
  labelConsulting:any=""

  popupCustomer2:boolean = false
  popupCustomer3:boolean = false
  addCustomerButtonAwardingJob:any

  defaultBidStatus: any = 0;

  @ViewChild('newcustomer', { static: false }) newcustomer: NewCustomerComponent;

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private toast: ToastService,
    private siteService: SiteService,
    private contactService: ContactService,
    private activatedroute: ActivatedRoute,
    private customerService: CustomerService,
    public appConfigService: AppConfigService,
    private salesLeadService: SalesleadService,
    private settingsCompany: CompanySettingsService,
    private salesProjectService: SalesProjectService,
    public MapInformationService: MapInformationService,
    public SystemComponentService: SystemComponentService,
    private translate:TranslateService,
    public GeneralService: GeneralService,
    //private googleMapsLoaderService: GoogleMapsLoaderService
  ) {
    //this.loadGoogleMaps();
    this.dateFormat = appConfigService.dateFormat;
    this.settings.dateFormat = this.appConfigService.dateFormat;
    this.settings.moneyFormat = this.appConfigService.moneyFormat;
    let moneyTableFormat = this.settings.moneyFormat;
    if(this.appConfigService.moneyFormat=='$'){ moneyTableFormat = 'USD' }

    this.formatCurrency = {style: 'currency', currency: moneyTableFormat}
    //console.log(this.formatCurrency)
    this.getPipelineId();

    this.DateFilter = new Date().getTime()
    this.DateFilterBid = new Date().getTime()
    // this.DateFilterClose = 0

    localStorage.removeItem("VolverSalesProject")
    localStorage.removeItem("VolverSalesProjectID")


    this.getLeadStatus()


    this.todayButton = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        this.DateFilter = new Date().getTime();
      }
    };

    this.prevDateButton = {
        icon: "spinprev",
        stylingMode: "text",
        onClick: () => {
          this.DateFilter -= this.millisecondsInDay;
        }
    };

    this.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        this.DateFilter += this.millisecondsInDay;
      }
    };

    this.todayButtonBid = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        this.DateFilterBid = new Date().getTime();
      }
    };

    this.prevDateButtonBid = {
        icon: "spinprev",
        stylingMode: "text",
        onClick: () => {
          this.DateFilterBid -= this.millisecondsInDay;
        }
    };

    this.nextDateButtonBid = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        this.DateFilterBid += this.millisecondsInDay;
      }
    };

    this.todayButtonClose = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        this.DateFilterClose = new Date().getTime();
      }
    };

    this.prevDateButtonClose = {
        icon: "spinprev",
        stylingMode: "text",
        onClick: () => {
          if(isNaN(this.DateFilterClose)){
            this.DateFilterClose = new Date().getTime();
          }
          this.DateFilterClose -= this.millisecondsInDay;
        }
    };

    this.nextDateButtonClose = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        if(isNaN(this.DateFilterClose)){
          this.DateFilterClose = new Date().getTime();
        }
        this.DateFilterClose += this.millisecondsInDay;
      }
    };


    this.dataSource = [
      { ID: 1085, TaskName: 'Bugs Quality Controls (SLS-ACT)', Hour: 1.5, SumaryTask: 'El Gallo', actualHour: '10:16', StartDate: '08/20/2020', dueDate: '08/20/2020', pCom: 50, pToEndOfMonth: 0.00, Responsible: 'JB', Resources: 'JB', Area: 'Sist Act', Priority: 'Normal', Status: 'IP', Category: 'DEV Front' },
      { ID: 1086, TaskName: 'Complete Front End Development  (PL)', Hour: 1.5, SumaryTask: 'El Gallo', actualHour: '10:16', StartDate: '08/20/2020', dueDate: '08/20/2020', pCom: 50, pToEndOfMonth: 0.00, Responsible: 'JB', Resources: 'JB', Area: 'Sist Act', Priority: 'Normal', Status: 'IP', Category: 'DEV Qa' },
      { ID: 1087, TaskName: 'Complete Quality Controls (PL)', Hour: 1.5, SumaryTask: 'El Gallo', actualHour: '10:16', StartDate: '08/20/2020', dueDate: '08/20/2020', pCom: 50, pToEndOfMonth: 0.00, Responsible: 'JB', Resources: 'JB', Area: 'Sist Act', Priority: 'Hight', Status: 'IP', Category: 'DEV Technicial' },
      { ID: 1088, TaskName: 'Create UI Wire Frame (SLSP)', Hour: 1.5, SumaryTask: 'Los Gallo', actualHour: '10:16', StartDate: '08/20/2020', dueDate: '08/20/2020', pCom: 50, pToEndOfMonth: 0.00, Responsible: 'JB', Resources: 'JB', Area: 'Sist Act', Priority: 'Low', Status: 'IP', Category: 'DEV Front' },
      { ID: 1089, TaskName: 'Complete Front End Development (SLSP)', Hour: 1.5, SumaryTask: 'El Gachio', actualHour: '10:16', StartDate: '08/20/2020', dueDate: '08/20/2020', pCom: 50, pToEndOfMonth: 0.00, Responsible: 'JB', Resources: 'JB', Area: 'Sist Act', Priority: 'Low', Status: 'IP', Category: 'DEV Database' }
    ]

    //modales
    this.plusSiteButton = {
      icon: "plus",
      type: "button",
      onClick: () => {
        this.popupServiceSite = true;
      },
      disabled: this.disableInputs
    };

    this.addCategoryButton = {
      icon: "edit",
      type: "button",
      onClick: () => {
        this.popupUtilityTable = true;
      },
      disabled: this.disableInputs
    };

    this.addConsultingButton = {
      icon: "plus",
      type: "button",
      onClick: () => {
        this.popupCustomer = true;
      },
      disabled: this.disableInputs
    };

    this.addSalesPersonButton = {
      icon: "edit",
      type: "button",
      onClick: () => {
        this.popupSalesPerson = true;
      },
      disabled: this.disableInputs
    };

    this.addCustomerButton = {
      icon: "plus",
      type: "button",
      onClick: () => {
        this.popupCustomer2 = true;
      },
      disabled: this.disableInputs
    };

    this.addCustomerButtonAwardingJob = {
      icon: "plus",
      type: "button",
      onClick: () => {
        this.popupCustomer3 = true;
      },
      disabled: this.disableInputs
    };

    this.addRequestByButton = {
      icon: "plus",
      type: "button",
      onClick: () => {
        this.popupNewContact = true;
      },
      disabled: this.disableInputs
    };

    this.addVerticalMaButton = {
      icon: "edit",
      type: "button",
      onClick: () => {
        this.popupUtilityTableVertical = true;
      },
      disabled: this.disableInputs
    };

    this.addProdSpeButton = {
      icon: "edit",
      type: "button",
      onClick: () => {
        this.popupMarketAnalysis = true;
      },
      disabled: this.disableInputs
    };

    this.addProdSpeButton2 = {
      icon: "edit",
      type: "button",
      onClick: () => {
        this.popupMarketAnalysis2 = true;
      },
      disabled: this.disableInputs
    };

    this.addProdSpeButtonNOTBIDREASON = {
      icon: "edit",
      type: "button",
      onClick: () => {
        this.popupaddProdSpeButtonNOTBIDREASON = true;
      },
    };



    this.cancelButtonNewCustomer = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.closeModal()
      },
    };

    this.saveButtonNewCustomer = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newcustomer.submitForm(true, false);
      },
      // disabled:this.newcustomer._formEntity.value.customername == ""
    };

    this.saveNewButtonNewCustomer = {
      text: this.translate.instant('btnSaveNew'),
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newcustomer.submitForm(false, false);
      },

    };

    this.saveEditButtonNewCustomer = {
      text: this.translate.instant('btnSaveEdit'),
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newcustomer.submitForm(true, true);
      },
    };

  // refresh price
  this.cancelButtonDeletePrice = {
    text: this.translate.instant('btnCancel'),
    elementAttr: {
      id: "bton-gray",
    },
    onClick: () => {
      this.closeDataPrice()
    },
  };

  this.saveButtonDeletePrice = {
    text: this.translate.instant('btnSave'),
    icon: "check",
    elementAttr: {
      id: "bton-green",
    },
    onClick: () => {

      console.log(this.optionSelected)
      if(this.optionSelected == 0){
        this.MapInformationService.SaveInfoSites({method:"SyncProjectCost", projectid:this.projectid, estimateid:0})
        .subscribe(resp=>{
          this.toast.success("Updated Successfully")
          this.closeDataPrice()
          this.ngOnInit()
        })
      } else {
        this.MapInformationService.SaveInfoSites({method:"SyncProjectCost", projectid:this.projectid, estimateid:this.estimateid})
        .subscribe(resp=>{
          this.toast.success("Updated Successfully")
          this.closeDataPrice()
          this.ngOnInit()
        })
      }
    },
  };


  this.addleadSatatus = {
    icon: "edit",
    type: "button",
    onClick: () => {
      this.popupLeadStatus = true;
    },
  };

  }

  getSalesStatus(){
    let data = {
      method:"Get_ProjectSalesLeadStatus"
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(result=>{
    // this.GeneralService.getPopulateGeneral('ProjectSalesLeadStatus').subscribe(result => {
      this.optionsSalesLeadStatus = result.map((val) => {
        return { // Return the new object structure
          label: val.NAME, value: val.ID
        };
      });
    });
  }

  

  appNotesDataSource
  popupMarketAnalysis2:boolean=false
  popupEstimateSelect:boolean=false
  addProdSpeButton2:any
  optionSelected:any=0
  estimateid:any=0
  popupLeadStatus:boolean=false

  @ViewChild("newCustomerRequestingSelect", { static: false }) newCustomerRequestingSelect: DxSelectBoxComponent;
  @ViewChild("newCustomerAwardingSelect", { static: false }) newCustomerAwardingSelect: DxSelectBoxComponent;
  @ViewChild("newRequestBySelect", { static: false }) newRequestBySelect: DxSelectBoxComponent;

  closeModal(){
    this.popupCustomer = false;
    this.popupCustomer2 = false;
    this.popupCustomer3 = false;
  }

  projectSold: boolean = false;

  ngOnInit() {
    console.log('ESTOY EN NGONIT ');
    this.settingsCompany.GetClientSettings("DefaultBidStatus").subscribe(data => {
      this.defaultBidStatus = Number(data[0].VALUE);
      	
      	this.initFormProjectDetail();
    	
    })

      this.initFormProjectDetail();
      this.getBidStatus();
      this.getMarketingCampaign();
      this.getProjectVerticalMarket();
      this.getSites();
      this.getCustomer();
      this.getProductSpecified();
      this.getPrevailingWages();
      this.getProjectCategory()

      this.getProjectNotBidReason();
      this.getClientCompetitor();
      this.getSalesPerson();

      this.getEmployeesNoSales()

      this.getConsultingFirm()

      if (this.projectid > 0){
        this.getSalesProject();
        this.getStatusbyDefault()
      }



    let mythis = this;
    // this.customerDataSource = new DataSource({
    //   load: function (loadOptions: any) {
    //     return mythis.customerService.GetCustomerByName(loadOptions.searchValue)
    //       .toPromise()
    //       .then((data: any) => {
    //         return data;
    //       })
    //       .catch(error => { throw 'Data Loading Error' });
    //   }
    // });

    // this.customerWithCreditDataSource = new DataSource({
    //   load: function (loadOptions: any) {
    //     return mythis.customerService.GetCustomerWithCreditListByName(loadOptions.searchValue)
    //       .toPromise()
    //       .then((data: any) => {
    //         return data;
    //       })
    //       .catch(error => { throw 'Data Loading Error' });
    //   }
    // });



    // this.contactDataSource = new DataSource({
    //   load: function (loadOptions: any) {
    //     return mythis.contactService.GetContactByName(loadOptions.searchValue)
    //       .toPromise()
    //       .then((data: any) => {
    //         return data;
    //       })
    //       .catch(error => { throw 'Data Loading Error' });
    //   }
    // });

    /***select nueva version */
    this.contactDataSource = []
    this.customerDataSource = []

    this.customerWithCreditDataSource = []


    this.customerWithCreditDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_CustomerCEWithCredit_ByName",loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            //console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName",loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            //console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    this.customerDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_CustomerCE_ByName",loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            //console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    this.MapInformationService.SaveInfoSites({method:"Get_DefaultConsultingfirm"})
    .subscribe(resp=>{
      this.MarkAsConsulting = resp
      if(resp.length > 0){
        let infoFinal = ""
        resp.forEach(element => {
         if (infoFinal == ""){
          infoFinal = element.CUSTOMERTYPE
         } else {
          infoFinal += ", " +element.CUSTOMERTYPE
         }
        });
        this.labelConsulting = "Select a costumer marked as "+ infoFinal
      } else {
        this.labelConsulting = "Select a costumer"
      }
    })

    this.isnew = true;
    this.disableInputs = false;
  }

  // loadGoogleMaps(): void {
  //   console.log('Loading Map in Sales  XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX')
  //   const apiKey = 'AIzaSyAEwfQAhTVBE9T6dzNtHRi11GDKLVUMuWw'; // Replace with your API key
  //   //const apiKey = this.appConfigService.appConfig.googleMapAPIKey //'AIzaSyAEwfQAhTVBE9T6dzNtHRi11GDKLVUMuWw'; // Replace with your API key
    
  //   this.googleMapsLoaderService.loadGoogleMapsScript(apiKey).subscribe(() => {
  //     // Google Maps API script is loaded and ready to use
  //     // Initialize ngx-google-places-autocomplete or other components here
  //   });
  // }


  MarkAsConsulting:any = []

  getConsultingFirm(){
    const info = {
      method:"Get_SalesLeadConsultingFirm"
    }

    this.MapInformationService.SaveInfoSites(info)
    .subscribe(resp=>{
      //console.log(resp)
      this.customerDataSource2 = resp
    })
  }

  changeAppNotes(obj) {
    if (obj && obj.selectedItem) {
      // //console.log(obj)
      // this.modelBillOfMaterial.appnoteid = obj.selectedItem.ID;
      // this.modelBillOfMaterial.appnote = obj.selectedItem.Application_Notes;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.projectid != undefined && changes.projectid.previousValue !== undefined) {
      this.initFormProjectDetail()
      this.ngOnInit()
    }
  }

  getPipelineId() {

    let pipelineid = this.activatedroute.snapshot.queryParamMap.get('numPIPELINEID');

    if (pipelineid)
      this.pipelineid = parseInt(pipelineid);

  }
  goEditPipeline() {
    this.router.navigateByUrl(`/pipeline/editPipeLine?numID=${this.pipelineid}&numPROJECTID=${this.projectInfo.projectid}`);
  }

  getFormValidationErrors() {
    let hasError = false;
    let value = this._projectDetailForm.value;
    //console.log('Validating', value);

    if (value.bidstatus == 3) {
      if (!value.closedate) {
        this.toast.warning(this.translate.instant('msgCloseDate'));
        hasError = true;
      }

      if (!value.amount) {
        this.toast.warning(this.translate.instant('msgQuoAmo'));
        hasError = true;
      }

      if (!value.profit) {
        this.toast.warning(this.translate.instant('msgSaleMarg'));
        hasError = true;
      }

      if (!value.salesemp) {
        this.toast.warning(this.translate.instant('msgSalPerson'));
        hasError = true;
      }

      if (!value.salescategoryid) {
        this.toast.warning(this.translate.instant('msgSaleCateg'));
        hasError = true;
      }

      if (!value.custawardprojectid) {
        this.toast.warning(this.translate.instant('msgCustAwJob'));
        hasError = true;
      }
    }

    // if(!value.custreqpriceid){
    //   this.toast.warning('Please enter Customer requesting this price');
    //   hasError = true;
    // }

    return hasError;
  }

  getEmployeesNoSales() {
    this.salesProjectService.GetEmployeesNoSales().subscribe(result => {
      // //console.log('no sales', result);
      this.employeesNoSalesSelect = result;
    })
  }

  addToSalesPerson() {
    let employeesToAdd = this.employeesNoSalesSelect.filter(x => x.add == true);

    employeesToAdd.forEach(element => {
      this.salesProjectService.UpdateEmployeeToSales(element.ID).subscribe(result => {
        this.getSalesPerson();
        this.getEmployeesNoSales();
        this._projectDetailForm.get("salesemp").setValue(element.ID)
      });

    });

    this.toast.success(this.translate.instant('msgSalPerSuccUdp'));
    this.popupSalesPerson = false;
  }

  changeEmployeeNoSales(obj, item) {
    item.add = obj.value;
  }
  mdItemRegion() {
    this.popupMarketRegion = true;
  }

  mdItemCompanies() {
    this.popupMarketCompanies = true;
  }


  onCustomItemCreating(args) {
    let newValue = args.text;
    this.editableProducts.unshift(newValue);
    args.customItem = newValue;
  }

  openModalNewContact() {
    this.popupNewContact = true;
    // let modalOptions = {
    //   // backdrop: true,
    //   // keyboard: true,
    //   // focus: true,
    //   // show: false,
    //   ignoreBackdropClick: true,
    //   class: 'modal-dialog modal-lg',
    //   // containerClass: '',
    //   // animated: true,
    //   data: {
    //     // customerSelect: this.customerSelect
    //     // text: 'Modal heading',
    //     // content: { heading: 'Content heading', description: 'Content description' }
    //   }
    // };
    // this.modalRef = this.modalService.show(NewContactComponent, modalOptions);

    // this.modalRef.content.action.subscribe((result: any) => {
    //   console.clear();
    //   // this.loadContaDefault(result.data);
    //   //console.log(result);

    //   // Esta propiedad devuelve el ID creado del contacto.
    //   // result.data
    //   // if (result.success) {
    //   //   this.getAllContacts();
    //   // }
    // });
  }

  mdMarketingCampaign() {
    this.popupMarketCampaign = true;
  }

  mdMarketAnalysis() {
    this.popupMarketAnalysis = true;
  }

  getClientCompetitor() {
    this.salesProjectService.GetClientCompetitor().subscribe(result => {
      this.awardToSelect = result;
    });
  }

  getProjectNotBidReason() {
    this.salesProjectService.GetProjectNotBidReason().subscribe(result => {
      this.notBidReasonSelect = result;
    });
  }

  handleAddressChange(res) {
    //console.log(res);
    this._projectDetailForm.get('lon').setValue(res.geometry.location.lng());
    this._projectDetailForm.get('lat').setValue(res.geometry.location.lat());
    this._projectDetailForm.get('address').setValue(res.formatted_address);

    for (var i = 0; i < res.address_components.length; i++) {
      for (var j = 0; j < res.address_components[i].types.length; j++) {
        if (res.address_components[i].types[j] == "postal_code") {
          this._projectDetailForm.get('zip').setValue(res.address_components[i].long_name);
        }
        if (res.address_components[i].types[j] == "administrative_area_level_1") {
          this._projectDetailForm.get('state').setValue(res.address_components[i].long_name);
        }
        if (res.address_components[i].types[j] == "locality") {
          this._projectDetailForm.get('city').setValue(res.address_components[i].long_name);
        }
        if (res.address_components[i].types[j] == "country") {
          this._projectDetailForm.get('country').setValue(res.address_components[i].long_name);
        }
      }
    }

  }

  onCellPrepared(ev) { }
  clearEvents() {
    this.events = [];
  }

  logEvent(eventName) {
    this.events.unshift(eventName);
    //console.log(this.events);
    //console.log(eventName);
  }

  InsertUpdateVerticalMarket(ev) {
    //console.log(ev);
    let model = {
      id: 0,
      verticalmarketdescription: ''
    };
    if (ev.data.ID && ev.data.ID > 0) {
      model.id = ev.data.ID;
    }

    model.verticalmarketdescription = ev.data.VERTMARKETDESCRIPTION;

    this.salesProjectService.InsertUpdateVerticalMarket(model).subscribe(result => {
      //console.log('nitido', result);
      this.getProjectVerticalMarket();
    });
  }

  insertUpdateProjectCategory(ev) {
    //console.log(ev);
    let model = {
      id: 0,
      projectslscategory: ''
    };

    if (ev.data) {
      model.id = 0;
      model.projectslscategory = ev.data.PROJECTSLSCATEGORY;
    } else if (ev.newData) {
      model.id = ev.key;
      model.projectslscategory = ev.newData.PROJECTSLSCATEGORY;
    }

    //console.log(JSON.stringify(model))
    //console.log(this.projectCategorySelect)

    this.salesProjectService.InsertUpdateSalesCategory(model).subscribe(result => {
      this.getProjectCategory();
    })
  }

  mdUtiliyTable() {
    this.popupUtilityTable = true;
  }
  close() {

    $('#btnlimpiarmodalservicesite').click();
    //console.log('aqui cerre')
  }
  getSalesProject() {
    let model = {
      PageIndex: 1,
      PageSize: 20,
      OrderID: 1,
      ProjectNumber: '',
      ProjectId: this.projectid,
      ProjectName: '',
      Amount: '',
      BidDate: '',
      BidStatus: '',
      CloseDate: '',
      CustomerName: '',
      SalesPerson: '',
      SalesCategory: ''
    };

    this.MapInformationService.SaveInfoSites({method:"Get_SalesProject_ById", projectid:this.projectid})
    .subscribe(resp=>{
      console.log('Sales Project ', resp);
      if (resp.length > 0){
        if (resp[0].IsPipeline == 1){
          this.pipelineid = resp[0].PIPELINEID
        }
      }
      
      this.salesProjectService.GetSalesProject(model).subscribe(result => {
        //console.log('project', result);
        result.data[0].salesnotes = resp[0].SALESNOTES
        this.setFormProjectDetail(result.data[0]);
        this.projectInfo = {
          projectid: result.data[0].PROJECTID,
          projectname: result.data[0].PROJECTNAME,
          projectaddress: '',
          projectnumber: result.data[0].PROJECTNUMBER,
          statusid: result.data[0].BIDSTATUS
        }
        this.newCustomerRequestingSelect.placeholder = result.data[0].CUSREQPRICENAME
        this.newCustomerAwardingSelect.placeholder = result.data[0].BUYERNAME
        this.newRequestBySelect.placeholder = result.data[0].REQUESTBYNAME


        this.getprojectinfo.emit(this.projectInfo);
      });
    })
  }

  resultNewSite(obj) {
    this.getSites();
    this._projectDetailForm.get('siteid').setValue(obj.id);
  }

  onsavecontact(ev) {
    console.log(ev)
    let obj = {
      selectedItem: {
        ID: ev.id,
        First: ev.First,
        Last: ev.Last
      }
    };

    this._projectDetailForm.get('partestimaterequestbyid').setValue(ev.id);
    this.partestimaterequestbyname = ev.id
    this.newRequestBySelect.placeholder = ev.First + " " + ev.Last + " (" + ev.Email + ")"

    // this.newRequestBySelect

    let mythis = this
    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = "je"
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.contactService.GetContactByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            //console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    // this.updateContactId(obj);
  }
  resultNewCustomer(ev) { /*console.log(ev);*/ }

  resultulCustumerOriginal(ev) {
    //console.log(ev);

    let obj = {
      selectedItem: {
        ID: ev.id,
        DESCRIPTION: ev.name
      }
    };

    this._projectDetailForm.get("consultingid").setValue(ev.id)

    if (this.customerField == 'consultingname') {
      this.updateConsultingFirm(obj);
    }

    if (this.customerField == 'custreqpricename') {
      this.updateCustomerRequestPrice(obj);
    }

  }

  /* Para project detail */

  onStatusChange(ev) {
    // //console.log(ev);
    const previousValue = ev.previousValue;
    const newValue = ev.value;

    if (newValue == 3) {
      this._projectDetailForm.get('salescategoryid').setValidators([Validators.required])
      if (!this._projectDetailForm.get('salescategoryid').value) {
        this._projectDetailForm.get('salescategoryid').setValue(null);
      }

      this._projectDetailForm.get('salesemp').setValidators([Validators.required])
      if (!this._projectDetailForm.get('salesemp').value) {
        this._projectDetailForm.get('salesemp').setValue(null);
      }

      this._projectDetailForm.get('consultingid').setValidators([Validators.required])
      if (!this._projectDetailForm.get('consultingid').value) {
        this._projectDetailForm.get('consultingid').setValue(0);
        this.consultingname = 'UNKNOWN';
      }

      this._projectDetailForm.get('custawardprojectid').setValidators([Validators.required])
      if (!this._projectDetailForm.get('custawardprojectid').value) {
        this._projectDetailForm.get('custawardprojectid').setValue(null);
      }

      this._projectDetailForm.get('closedate').setValidators([Validators.required])
      if (!this._projectDetailForm.get('closedate').value) {
        this._projectDetailForm.get('closedate').setValue(null);
      }

      this._projectDetailForm.get('amount').setValidators([Validators.required, Validators.min(1)])
      if (!this._projectDetailForm.get('amount').value) {
        this._projectDetailForm.get('amount').setValue(0.00);
      }

      this._projectDetailForm.get('profit').setValidators([Validators.required])
      if (!this._projectDetailForm.get('profit').value) {
        this._projectDetailForm.get('profit').setValue(0);
      }

    } else {
      this._projectDetailForm.get('salescategoryid').clearValidators();
      this._projectDetailForm.get('profit').clearValidators();
      this._projectDetailForm.get('amount').clearValidators();
      this._projectDetailForm.get('closedate').clearValidators();
      this._projectDetailForm.get('custawardprojectid').clearValidators();
      this._projectDetailForm.get('consultingid').clearValidators();
      this._projectDetailForm.get('salesemp').clearValidators();
    }



    if (!this._projectDetailForm.get('salescategoryid').value) {
      this._projectDetailForm.get('salescategoryid').setValue(null);
    }


    if (!this._projectDetailForm.get('salesemp').value) {
      this._projectDetailForm.get('salesemp').setValue(null);
    }


    if (!this._projectDetailForm.get('consultingid').value) {
      this._projectDetailForm.get('consultingid').setValue(0);
      this.consultingname = 'UNKNOWN';
    }


    if (!this._projectDetailForm.get('custawardprojectid').value) {
      this._projectDetailForm.get('custawardprojectid').setValue(null);
    }


    if (!this._projectDetailForm.get('closedate').value) {
      this._projectDetailForm.get('closedate').setValue(null);
    }


    if (!this._projectDetailForm.get('amount').value) {
      this._projectDetailForm.get('amount').setValue(0.00);
    }


    if (!this._projectDetailForm.get('profit').value) {
      this._projectDetailForm.get('profit').setValue(0);
    }

  }

  initFormProjectDetail() {
    //console.log('Iniciando Form');
    this.isnew = true;
    this.disableInputs = false;
    this._projectDetailForm = new FormGroup({
      bidreqdate: new FormControl({ value: new Date(), disabled: false }, []),
      biddate: new FormControl({ value: new Date(), disabled: false }, []),
      projectid: new FormControl({ value: 0, disabled: false }, []),
      projectnum: new FormControl({ value: null, disabled: false }, []),
      name: new FormControl({ value: '', disabled: false }, []),
      siteid: new FormControl({ value: 0, disabled: false }, []),
      salescategoryid: new FormControl({ value: 0, disabled: false }, []),
      bidstatus: new FormControl({ value: this.defaultBidStatus, disabled: false }, []),
      closedate: new FormControl({ value: '', disabled: false }, []),
      amount: new FormControl({ value: 0.00, disabled: false }, []),
      profit: new FormControl({ value: 0, disabled: false }, []),
      profitpercent: new FormControl({ value: 0, disabled: false }, []),
      consultingid: new FormControl({ value: 0, disabled: false }, []),
      salesemp: new FormControl({ value: 0, disabled: false }, []),
      custreqpriceid: new FormControl({ value: 0, disabled: false }, []),
      custawardprojectid: new FormControl({ value: 0, disabled: false }, []),
      // contactid: new FormControl({ value: '', disabled: false }, []),
      projectverticalid: new FormControl({ value: 0, disabled: false }, []),
      awardedto: new FormControl({ value: 0, disabled: false }, []),
      // marketcampid: new FormControl({ value: '', disabled: false }, []),
      productspecified: new FormControl({ value: 0, disabled: false }, []),
      // prevailingwage: new FormControl({ value:'', disabled: false }, []),
      partestimaterequestbyid: new FormControl({ value: 0, disabled: false }, []),
      prevailingwagecode: new FormControl({ value: 0, disabled: false }, []),
      notbidreason: new FormControl({ value: 0, disabled: false }, []),
      salescomment: new FormControl({ value: '', disabled: false }, []),
      salesnotes: new FormControl({ value: '', disabled: false }, []),

      address: new FormControl({ value: '', disabled: false }, [Validators.required]),
      addressline2: new FormControl({ value: '', disabled: false }, []),
      city: new FormControl({ value: '', disabled: false }, []),
      state: new FormControl({ value: '', disabled: false }, []),
      country: new FormControl({ value: '', disabled: false }, []),
      zip: new FormControl({ value: '', disabled: false }, []),
      lat: new FormControl({ value: 0, disabled: false }, []),
      lon: new FormControl({ value: 0, disabled: false }, []),


    });

    this.consultingname = "";
    this.custawardprojectname = "";
    this.partestimaterequestbyname = "";
    this.custreqpricename = "";
    //console.log('Default', this.defaultBidStatus);
    //console.log('FOORM',this._projectDetailForm.value);
  }

  setFormProjectDetail(val) {
    console.log('FORM PROJECT ', val)
    // val.SALESCATEGORYID
    this.isnew = false;
    //console.log(this.VieneDe)
    //console.log(val.DOLLARAMOUNT)
    //console.log('Voy por auqi ');
    val.BIDSTATUS = val.BIDSTATUS == null ? this.defaultBidStatus : val.BIDSTATUS;

    this.projectSold = val.BIDSTATUS == 3;

    this.updateStatus.emit(this.projectSold);

    if(this.VieneDe == "SWO"){
      this.disableInputs = false;

      this.ispipeline.emit(val.IsPipeline == 1);

      if (this.disableInputs)
        this.omitirsave.emit(true);

      //console.log(val.BIDREQUESTDATE)
      //console.log(val.BIDDATE)
      if(val.BIDREQUESTDATE == "1753-01-01T00:00:00"){val.BIDREQUESTDATE = this.datePipe.transform(new Date(), 'yyyyMMdd')}
      if(val.BIDDATE == "1753-01-01T00:00:00"){val.BIDDATE = this.datePipe.transform(new Date(), 'yyyyMMdd')}


      this._projectDetailForm = new FormGroup({
        bidreqdate: new FormControl({ value: val.BIDREQUESTDATE, disabled: false }, []),
        biddate: new FormControl({ value: val.BIDDATE, disabled: false }, []),
        projectid: new FormControl({ value: this.projectid, disabled: false }, []),
        projectnum: new FormControl({ value: val.PROJECTNUMBER, disabled: false }, []),
        name: new FormControl({ value: val.PROJECTNAME, disabled: false }, []),
        siteid: new FormControl({ value: val.SITEID, disabled: false }, []),
        salescategoryid: new FormControl({ value: val.SALESCATEGORYID, disabled: false }, []),
        bidstatus: new FormControl({ value: val.BIDSTATUS, disabled: false }, []),
        closedate: new FormControl({ value: val.STRSALESCLOSEDATE, disabled: false }, []),
        amount: new FormControl({ value: val.DOLLARAMOUNT, disabled: false }, []),
        profit: new FormControl({ value: val.PROFFITMARGIN, disabled: false }, []),
        profitpercent: new FormControl({ value: val.PROFFITMARGIN * 100, disabled: false }, []),
        consultingid: new FormControl({ value: val.DESIGNERID, disabled: false }, []),

        salesemp: new FormControl({ value: val.SALESEMPLOYEE, disabled: false }, []),
        custreqpriceid: new FormControl({ value: val.CUSTOMERREQPRICEID, disabled: false }, []),
        custawardprojectid: new FormControl({ value: val.CONTRACTORBUYER, disabled: false }, []),
        partestimaterequestbyid: new FormControl({ value: val.PARTESTIMATEREQUESTBYID, disabled: false }, []),
        projectverticalid: new FormControl({ value: val.PROJECTVERTICALID, disabled: false }, []),
        awardedto: new FormControl({ value: val.AWARDEDTO, disabled: false }, []),
        // marketcampid: new FormControl({ value: val.MARKETCAMPID, disabled: false }, []),
        productspecified: new FormControl({ value: val.PRODUCTSPECIFIED, disabled: false }, []),
        // prevailingwage: new FormControl({ value: val.PREVAILINGWAGES, disabled: false }, []),
        prevailingwagecode: new FormControl({ value: val.PREVAILINGWAGESCODE, disabled: false }, []),
        notbidreason: new FormControl({ value: val.NOTBIDREASON, disabled: false }, []),
        salescomment: new FormControl({ value: val.SALESCOMMENTS, disabled: false }, []),
        salesnotes: new FormControl({ value: val.salesnotes, disabled: false }, []),

        address: new FormControl({ value: val.ADDRESS, disabled: false }, []),
        addressline2: new FormControl({ value: val.ADDRESSLINE2, disabled: false }, []),
        city: new FormControl({ value: val.CITY, disabled: false }, []),
        state: new FormControl({ value: val.STATE, disabled: false }, []),
        country: new FormControl({ value: val.COUNTRY, disabled: false }, []),
        zip: new FormControl({ value: val.ZIP, disabled: false }, []),
        lat: new FormControl({ value: val.LAT, disabled: false }, []),
        lon: new FormControl({ value: val.LON, disabled: false }, []),

      });

      this.consultingname = val.DESIGNERNAME;
      this.custawardprojectname = val.BUYERNAME;
      this.partestimaterequestbyname = val.REQUESTBYNAME;
      this.custreqpricename = val.CUSREQPRICENAME;

    } else {
      this.disableInputs = val.BIDSTATUS == 3;

      this.ispipeline.emit(val.IsPipeline == 1);

      if (this.disableInputs)
        this.omitirsave.emit(true);

      this._projectDetailForm = new FormGroup({
        bidreqdate: new FormControl({ value: val.BIDREQUESTDATE, disabled: false }, []),
        biddate: new FormControl({ value: val.BIDDATE, disabled: false }, []),
        projectid: new FormControl({ value: this.projectid, disabled: false }, []),
        projectnum: new FormControl({ value: val.PROJECTNUMBER, disabled: false }, []),
        name: new FormControl({ value: val.PROJECTNAME, disabled: false }, []),
        siteid: new FormControl({ value: val.SITEID, disabled: false }, []),
        salescategoryid: new FormControl({ value: val.SALESCATEGORYID, disabled: false }, []),
        bidstatus: new FormControl({ value: val.BIDSTATUS, disabled: false }, []),
        closedate: new FormControl({ value: val.STRSALESCLOSEDATE, disabled: false }, []),
        amount: new FormControl({ value: val.DOLLARAMOUNT, disabled: false }, []),
        profit: new FormControl({ value: val.PROFFITMARGIN, disabled: false }, []),
        profitpercent: new FormControl({ value: val.PROFFITMARGIN * 100, disabled: false }, []),
        consultingid: new FormControl({ value: val.DESIGNERID, disabled: false }, []),

        salesemp: new FormControl({ value: val.SALESEMPLOYEE, disabled: false }, []),
        custreqpriceid: new FormControl({ value: val.CUSTOMERREQPRICEID, disabled: false }, []),
        custawardprojectid: new FormControl({ value: val.CONTRACTORBUYER, disabled: false }, []),
        partestimaterequestbyid: new FormControl({ value: val.PARTESTIMATEREQUESTBYID, disabled: false }, []),
        projectverticalid: new FormControl({ value: val.PROJECTVERTICALID, disabled: false }, []),
        awardedto: new FormControl({ value: val.AWARDEDTO, disabled: false }, []),
        // marketcampid: new FormControl({ value: val.MARKETCAMPID, disabled: false }, []),
        productspecified: new FormControl({ value: val.PRODUCTSPECIFIED, disabled: false }, []),
        // prevailingwage: new FormControl({ value: val.PREVAILINGWAGES, disabled: false }, []),
        prevailingwagecode: new FormControl({ value: val.PREVAILINGWAGESCODE, disabled: false }, []),
        notbidreason: new FormControl({ value: val.NOTBIDREASON, disabled: false }, []),
        salescomment: new FormControl({ value: val.SALESCOMMENTS, disabled: false }, []),
        salesnotes: new FormControl({ value: val.salesnotes, disabled: false }, []),

        address: new FormControl({ value: val.ADDRESS, disabled: false }, []),
        addressline2: new FormControl({ value: val.ADDRESSLINE2, disabled: false }, []),
        city: new FormControl({ value: val.CITY, disabled: false }, []),
        state: new FormControl({ value: val.STATE, disabled: false }, []),
        country: new FormControl({ value: val.COUNTRY, disabled: false }, []),
        zip: new FormControl({ value: val.ZIP, disabled: false }, []),
        lat: new FormControl({ value: val.LAT, disabled: false }, []),
        lon: new FormControl({ value: val.LON, disabled: false }, []),

      });

      this.consultingname = val.DESIGNERNAME;
      this.custawardprojectname = val.BUYERNAME;
      this.partestimaterequestbyname = val.REQUESTBYNAME;
      this.custreqpricename = val.CUSREQPRICENAME;

    }

    if (val.SALESCATEGORYID == null){
      this._projectDetailForm.get('salescategoryid').setValue(this.projectCategorySelect.find(x => x.DEFAULT == 1).ID)
    }
  }

  getBidStatus() {
    // this.generalService.GetProjectBidStatus().subscribe(result => {
      this.MapInformationService.SaveInfoSites({method:"Estimates_Get_ProjectBidStatus"}).subscribe(result => {
      // //console.log(result)
      this.bidStatusSelect = result;
      // //console.log(this.bidStatusSelect)
      if (!this._projectDetailForm.get('bidstatus').value)
        // this._projectDetailForm.get('bidstatus').setValue(this.bidStatusSelect.find(x => x.DEFAULT == 1).ID)
        this._projectDetailForm.get('bidstatus').setValue(this.bidStatusSelect[0].ID)
    },error=>{
      //console.log(error)
    });
  }

  getMarketingCampaign() {
    this.salesProjectService.GetSalesLeadMarketingCampaign().subscribe(result => {
      this.marketingSelect = result;
    })
  }

  getProjectVerticalMarket() {
    // this.salesProjectService.GetProjectVerticalMarket().subscribe(result => {
    this.MapInformationService.SaveInfoSites({method:"Estimates_Get_ProjectVerticalMarket"}).subscribe(result => {
        // //console.log(result)
      this.verticalMarketSelect = result;
      if (!this._projectDetailForm.get('projectverticalid').value)
        this._projectDetailForm.get('projectverticalid').setValue(this.verticalMarketSelect.find(x => x.DEFAULT == 1).ID)
    });
  }

  getSites() {
    this.siteService.GetSites().subscribe(result => {
      this.siteSelect = result;
    });
  }

  getCustomer() {
    this.customerService.GetCustomerList().subscribe(result => {
      this.customerSelect = result;
    });
  }

  getProductSpecified() {
    this.MapInformationService.SaveInfoSites({method:"Get_Competitor"}).subscribe(result => {
    // this.salesLeadService.GetSalesLeadCompetitor().subscribe(result => {
      this.productSpecifiedSelect = result;
    });

  }

  getPrevailingWages() {
    this.salesProjectService.GetPrevailingWages().subscribe(result => {
      this.prevailingSelect = result;
    });
  }

  getSalesPerson() {
    // this.generalService.GetSalesPerson().subscribe(
      this.MapInformationService.SaveInfoSites({method:"Get_EmployeeSalesListAllCE"}).subscribe(
      data => {
        // //console.log(data)
        this.salesPersonSelect = data.map((val) => {
          // //console.log(val.value)
          return { // Return the new object structure
            label: val.CONTACTNAME,
            value: val.ID
          };
        });
      },
      err => {
        //console.log(err);
      }
    );
  }

  updateSalesProject(type = 1) {
    console.clear()
    //console.log(type);
    //console.log(this._projectDetailForm.value)
    if (this.getFormValidationErrors())
      return;

    let form = this._projectDetailForm.value;

    // if(form.address == "" || form.address == undefined){
    //   this.toast.warning("The Address field cannot be empty")
    //   return false
    // } else {
      // form.addressline2 = form.address
    // }

    if (!form.name) {
      form.name = 'New Estimate';
    }
    form.siteid = form.siteid ? form.siteid : 0;
    form.salescategoryid = form.salescategoryid ? form.salescategoryid : 0;
    form.amount = form.amount ? form.amount : 0;
    form.profit = form.profit ? form.profit : 0;
    form.bidstatus = form.bidstatus ? form.bidstatus : 0;
    form.profitpercent = form.profitpercent ? form.profitpercent : 0;
    form.consultingid = form.consultingid ? form.consultingid : 0;
    form.salesemp = form.salesemp ? form.salesemp : 0;
    form.custreqpriceid = form.custreqpriceid ? form.custreqpriceid : 0;
    form.custawardprojectid = form.custawardprojectid ? form.custawardprojectid : 0;
    form.projectverticalid = form.projectverticalid ? form.projectverticalid : 0;
    form.awardedto = form.awardedto ? form.awardedto : 0;
    form.productspecified = form.productspecified ? form.productspecified : 0;
    form.partestimaterequestbyid = form.partestimaterequestbyid ? form.partestimaterequestbyid : 0;
    form.prevailingwagecode = form.prevailingwagecode ? form.prevailingwagecode : 0;
    form.notbidreason = form.notbidreason ? form.notbidreason : 0;
    form.prevailingwage = 0;
    form.closedate = form.closedate ? this.datePipe.transform(form.closedate, 'yyyyMMdd') : '';
    form.bidreqdate = form.bidreqdate ? this.datePipe.transform(form.bidreqdate, 'yyyyMMdd') : '';
    form.biddate = form.biddate ? this.datePipe.transform(form.biddate, 'yyyyMMdd') : '';
    form.method = 'InsertUpdate_SalesProjectsCE';
    form.leadstatus = this.LeadStatus;
    
    //form.profit = form.profitpercent / 100;
    //console.log('FORMULARIO ',form);
    this.salesProjectService.InsertUpdateSalesProject(form).subscribe(result => {
      // this.MapInformationService.SaveInfoSites({method:"Insert_webLeads", leadstatus:this.LeadStatus, id:form.projectid}).subscribe(resultEstatus=>{
        let obj = {
          name: form.name,
          projectid: 0
        }
        if (this.isnew){
          this.ngOnInit();
          this.toast.success(this.translate.instant('msgProjSucc'));
  
        }else{
          this.getSalesProject();
          this.toast.success(this.translate.instant('msgUpdSucc'));
        }
  
        if (type == 1 || type == 3) {
          this.closemodal.emit();
        }
  
        // if (type == 2) {
        //   this.initFormProjectDetail();
        // }
  
        obj.projectid = result.length > 0 ? result[0].ReturnID : 0;
        this.onsave.emit(obj);
        if (type == 3) {
          this.router.navigateByUrl(`/salesProject/editSales/${result[0].ReturnID}`);
          //console.log('Save y Edit')
          this.toast.success(this.translate.instant('msgProjSucc'));
        }

      // })


    });
  }

  getProjectCategory() {
    // this.salesProjectService.GetProjectSalesCategory().subscribe(result => {
      this.MapInformationService.SaveInfoSites({method:"Estimates_Get_ProjectSalesCategory"}).subscribe(result => {
      // this.salesCategorySelect = result.map((val) => {
      //   return { // Return the new object structure
      //     label: val.PROJECTSLSCATEGORY,
      //     value: val.ID
      //   };
      // });
      this.projectCategorySelect = result;


      if (!this._projectDetailForm.get('salescategoryid').value){
        this._projectDetailForm.get('salescategoryid').setValue(this.projectCategorySelect.find(x => x.DEFAULT == 1).ID)
      }
    });
  }

  updateAwardingJob(item) {

    if (item.selectedItem.ID) {
      this._projectDetailForm.get('custawardprojectid').setValue(item.selectedItem.ID);
      // this.state = item.selectedItem.First + ' ' + item.selectedItem.Last;
    }
  }

  updateContactId(item) {

    if (item.selectedItem.ID) {
      this._projectDetailForm.get('partestimaterequestbyid').setValue(item.selectedItem.ID);
      //console.log(item.selectedItem)
      // this.state = item.selectedItem.First + ' ' + item.selectedItem.Last;
      this.partestimaterequestbyname = item.selectedItem.ContaNameID;
      //console.log(this.partestimaterequestbyname)
    }
  }

  test(item){
    //console.log(item)
  }

  goEditContact(CONTACT_ID) {
    this.router.navigateByUrl('/contacts/editContact/' + CONTACT_ID);
  }

  updateConsultingFirm(item) {

    if (item.selectedItem.ID) {
      this._projectDetailForm.get('consultingid').setValue(item.selectedItem.ID);
      this.consultingname = item.selectedItem.DESCRIPTION;
      // this.state = item.selectedItem.First + ' ' + item.selectedItem.Last;
    }
  }

  updateCustomerRequestPrice(item) {
    if (item.selectedItem.ID) {
      this._projectDetailForm.get('custreqpriceid').setValue(item.selectedItem.ID);
      this.custreqpricename = item.selectedItem.DESCRIPTION;
      // this.state = item.selectedItem.First + ' ' + item.selectedItem.Last;
    }
  }

  goEditCustomer(customerid) {
    this.router.navigateByUrl('/customers/editCustomer/' + customerid);
  }
  /* Fin Project detail */

  InsertNew(event){
    //console.log(event)
    const data = {
      method:"InsertUpdate_SalesNotBidReason",
      id:0,
      name:event.data.NAME,
      sort:"",
      active:1
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      this.toast.success("Not Bid Reason added Successfully")
      this.getProjectNotBidReason()
      this.popupaddProdSpeButtonNOTBIDREASON = false
    })
  }

  UpdateNorReasonNew(event){
    const data = {
      method:"InsertUpdate_SalesNotBidReason",
      id:event.data.ID,
      name:event.data.NAME,
      sort:"",
      active:1
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      this.toast.success("Not Bid Reason updated Successfully")
      this.getProjectNotBidReason()
      this.popupaddProdSpeButtonNOTBIDREASON = false
    })
  }

  insertNewCategory(event){
    //console.log(event)
    this._projectDetailForm.get("salescategoryid").setValue(event[0].ResultID)
    this.getProjectCategory()
  }

  getNewRequesting(ev){
    //console.log(ev)
    let mythis = this;
    this.custreqpricename = ev.id
    this._projectDetailForm.get('custreqpriceid').setValue(ev.id);
    this.newCustomerRequestingSelect.placeholder = ev.name

    // return mythis.customerService.GetCustomerByName(loadOptions.searchValue)

    this.customerDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = "cond"
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.SaveInfoSites({method:"Get_CustomerCE_ByName", name: loadOptions.searchValue})
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

  }

  getNewAwarding(ev){
    //console.log(ev)
    let mythis = this;
    this.custawardprojectname = ev.id
    this._projectDetailForm.get('custawardprojectid').setValue(ev.id);
    this.newCustomerAwardingSelect.placeholder = ev.name
    this.customerWithCreditDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = "cond"
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.customerService.GetCustomerWithCreditListByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            //console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  insertNewVerticalMarket(event){
    //console.log(event)
    this._projectDetailForm.get('projectverticalid').setValue(event[0].ResultID)
    this.getProjectVerticalMarket()
  }

  newAwardedTo(event){
    //console.log(event)
    this._projectDetailForm.get('awardedto').setValue(event[0].ResultID)
    this.getProductSpecified()
    this.getClientCompetitor()
  }

  newProductSpecified(event){
    //console.log(event)
    this._projectDetailForm.get('productspecified').setValue(event[0].ResultID)
    this.getProductSpecified()
    this.getClientCompetitor()
  }


  SetNotBidReason(event){
    //console.log(event)
    this._projectDetailForm.get('notbidreason').setValue(event[0].ResultID)
    this.getProjectNotBidReason()
  }

  GoToCustomer(){
    //console.log(this._projectDetailForm.value)
    // // custreqpriceid
    // projectid
    localStorage.removeItem("VolverSalesProject")
    localStorage.removeItem("VolverSalesProjectID")
    localStorage.setItem("VolverSalesProject","yes")
    localStorage.setItem("VolverSalesProjectID",this._projectDetailForm.value.projectid)
    this.router.navigateByUrl(`/customers/editCustomer/${this._projectDetailForm.value.custreqpriceid}`);
  }

  GoToCustomerJob(){
    //console.log(this._projectDetailForm.value)
    // // custreqpriceid
    localStorage.removeItem("VolverSalesProject")
    localStorage.removeItem("VolverSalesProjectID")
    localStorage.setItem("VolverSalesProject","yes")
    localStorage.setItem("VolverSalesProjectID",this._projectDetailForm.value.projectid)
    this.router.navigateByUrl(`/customers/editCustomer/${this._projectDetailForm.value.custawardprojectid}`);
  }

  GoToContact(){
    localStorage.removeItem("VolverSalesProject")
    localStorage.removeItem("VolverSalesProjectID")
    localStorage.setItem("VolverSalesProject","yes")
    localStorage.setItem("VolverSalesProjectID",this._projectDetailForm.value.projectid)
    this.router.navigateByUrl(`/contacts/editContact/${this._projectDetailForm.value.partestimaterequestbyid}`);
  }

  editSite(){
    localStorage.removeItem('newSite')
    localStorage.removeItem('VolverEditSalesProject')
    localStorage.setItem('newSite',this._projectDetailForm.value.siteid)
    localStorage.setItem('VolverEditSalesProject',this.projectid)
    this.router.navigate(['/serviceSites/editServiceSite']);
  }

  openRefreshPrice:boolean=false
  optionImportPrice:any[]=[
    {
      id:0,
      name:"Scope of Work"
    },
    {
      id:1,
      name:"Estimate Associated"
    }
  ]
  refresPrice(){
    this.openRefreshPrice = true
  }

  closeDataPrice(){
    this.openRefreshPrice = false;
    this.optionSelected = 0
  }

  showSelectEstimate:boolean = false
  estimate:any[]=[]
  showSelectEstimateFunction(event){
    console.log(event.value)
    if (event.value == 0){
      this.showSelectEstimate = false
    } else {
      const datos = {
        method:"Get_Projectestimate",
        projectid:this.projectid
      }
      // console.log(datos)
      this.MapInformationService.SaveInfoSites(datos)
      .subscribe(resp=>{
        this.estimate = resp
        this.showSelectEstimate = true
      })
    }
  }

  optionsSalesLeadStatus:any[] = []
  LeadStatus:any

  getLeadStatus(){
    let data = {
      method:"Get_ProjectSalesLeadStatus"
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(result=>{
    // this.GeneralService.getPopulateGeneral('ProjectSalesLeadStatus').subscribe(result => {
      this.optionsSalesLeadStatus = result.map((val) => {
        return { // Return the new object structure
          label: val.NAME, value: val.ID
        };
      });
    });
  }

  getStatusbyDefault(){ 
    // this.MapInformationService.SaveInfoSites({method:"Get_ProjectSalesLeadStatus"}).subscribe(result=>{
      this.GeneralService.getPopulateGeneral('SalesLead/GetSaleLeadById', this.projectid).subscribe(
      result => {
        console.log(result)
        this.LeadStatus = result[0].leadstatus
      })
  }

  setNewLeadsStatus(event){
    this.LeadStatus = event[0].ID
  }

}
